import React from 'react';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import Sidebar from '../sidebar/sidebar';
import MainContent from '../main-content/main-content';
import TopBar from '../topbar/topbar';

const DesktopLayout = ({ logoPath }) => (
  <div className="cm-dashboard flex h-[calc(100vh-0rem)] flex-col overflow-hidden">
    <TopBar logoPath={logoPath} />
    <div className="flex flex-1 overflow-hidden relative">
      <Sidebar />
      <MainContent>
        <Outlet />
      </MainContent>
    </div>
  </div>
);

DesktopLayout.defaultProps = {
  logoPath: '',
};

DesktopLayout.propTypes = {
  logoPath: PropTypes.string,
};

export default DesktopLayout;
